/// <amd-module name="Build/Admin/Checks/Actions/ActionsHub" />
import { Action } from "VSS/Reflux/Action";

import { TaskAgentPool, TaskAgentQueue } from "DistributedTask/Client/Contracts/TaskAgent";

import { NotificationActions } from "Build/Admin/Common/Actions/NotificationActions";
import { StoreStatus } from "Build/Admin/Common/Constants";

export class ActionsHub {
    public notificationActions = new NotificationActions();

    public selectedAgentPoolUpdated = new Action<TaskAgentPool | undefined>();
    public selectedAgentQueueUpdated = new Action<TaskAgentQueue | undefined>();
    public selectedTabUpdated = new Action<string>();
    public securityStoreStatusUpdated = new Action<StoreStatus>();
    public managePermissionUpdated = new Action<boolean>();
    public checkStoreStatusUpdated = new Action<StoreStatus>();
}
